module.exports = __webpack_public_path__ + "img/opcion-multiple.849c17e1.svg";